import db from './init'

export const categories = db.collection('categories')
export const domains = db.collection('domains')
export const advertisers = db.collection('advertisers')
export const profile = db.collection('profile')
export const posts = db.collection('posts')
export const promotors = db.collection('promotors')
export const shared_access = db.collection('shared_access')
export const workspace = db.collection('workspace')
export const groups = db.collection('groups')
export const groupMembers = db.collection('groupMembers')
export const groupDomains = db.collection('groupDomains')
